module.exports = __webpack_public_path__ + "img/阻力带深蹲.55f6acfb.png";